import React from 'react';
import _, { get, set } from 'lodash'
import moment from 'moment'

export const getSendErrColumns = (props) => {
    var columns = [
        {
            title: '视客货品名称',
            dataIndex: 'product_name',
            width:130,
            render: (text) => <span>{text || '--'}</span>
        },
        {
            title: '供应商货品编码',
            width:124,
            dataIndex: 'supplier_product_code',
            render: (text) => <span>{text || '--'}</span>
        },
        {
            title: '货品编码',
            dataIndex: 'product_code',
            render: (text) => <span>{text || '--'}</span>
        },
        {
            title: '生产日期',
            width:82,
            dataIndex: 'product_date',
            render: (text,record) => (
                <span style={get(record,'message_flag').includes(2)?{color:"red"}:{}}>{text ? moment(text).format('YYYY.MM.DD') : '--'}</span>
            )
        },
        {
            title: '失效日期',
            dataIndex: 'expira_date',
            width:82,
            render: (text) => (
                <span>{text ? moment(text).format('YYYY.MM.DD') : '--'}</span>
            )
        },
        {
            title: '注册证号',
            dataIndex: 'mdrc',
            render: (text) => <span>{text || '--'}</span>
        },
        {
            title: '注册证号有效时间',
            dataIndex: 'mdrc',
            width:163,
            render: (text,record) => <span style={get(record,'message_flag').includes(2)?{color:"red"}:{}}>{get(record,'begin_time') ? moment(get(record,'begin_time')).format('YYYY.MM.DD') : '--'}-{get(record,'end_time') ? moment(get(record,'end_time')).format('YYYY.MM.DD') : '--'}</span>
        },
        {
            title: '来货产品有效期',
            dataIndex: 'real_expiration',
            width:90,
            render: (text,record) => <span style={get(record,'message_flag').includes(1)?{color:"red"}:{}}>{text || text === 0 ? text + '天' : '--'}</span>
        },
        {
            title: '注册证产品有效期',
            dataIndex: 'expiration',
            width:90,
            render: (text,record) => <span style={get(record,'message_flag').includes(1)?{color:"red"}:{}}>{text || text === 0 ? text + '天' : '--'}</span>
        },
        {
            title: '原因',
            dataIndex: 'message',
            render: (text) => <span>{text || '--'}</span>
        }
    ]
    return columns
}



// WEBPACK FOOTER //
// ./src/pages/orderAdmin/config.js